export default {
    getterStoreAdjustmentDetailList: ({ list }) => list ?? [],
    getterConsumerStoreName: ({ consumerInfo }) => {
        const storeName = consumerInfo.businessName;
        if (!storeName) {
            return '';
        }
        return storeName;
    },
};
